import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";
import { StudentSessionAQACertificateModel } from "./Shared/StudentSessionAQACertificateModel";

export class StudentSessionAQACertificatesModel extends ModelBase<StudentSessionAQACertificatesModel> {
    public certificates = observable<StudentSessionAQACertificateModel>([]);
    constructor() {
        super();
        makeObservable(this, {});
    }
}

export class StudentSessionAQACertificatesModelValidator extends Validator<StudentSessionAQACertificatesModel> {
    constructor() {
        super();
    }
}
